/* eslint-disable no-param-reassign */
import template from './jk.jade';
import './typeahead-item.tpl.jade';
import './typeahead-popup.tpl.jade';
import validation from '../../../services/validation';
import {
  addJkMarkers,
  removeJkMarkers,
  addressChanged,
} from '../../../../blocks/segments/address/address.events';
import { get } from 'lodash';

export const MOSCOW_AND_AREA = -1;
export const ST_PETERSBURG_AND_AREA = -2;

const EARTH_RADIUS = 6371;
const MAX_DISTANCE_TO_JK = 10;

function degreesToRadians(deg) {
  return deg * (Math.PI / 180);
}

function distanceBetween(coordinateA, coordinateB) {
  if (!coordinateA || !coordinateB) {
    return undefined;
  }
  const dLat = degreesToRadians(coordinateB.lat - coordinateA.lat);
  const dLng = degreesToRadians(coordinateB.lng - coordinateA.lng);
  const squareOfHalfChordLengthBetweenPoints =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(coordinateA.lat)) * Math.cos(degreesToRadians(coordinateB.lat)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const angularDistanceInRadians = 2 * Math.atan2(
    Math.sqrt(squareOfHalfChordLengthBetweenPoints),
    Math.sqrt(1 - squareOfHalfChordLengthBetweenPoints)
  );

  return EARTH_RADIUS * angularDistanceInRadians;
}

export default angular
  .module('cian.addForm.jk', [])
  .directive('cianAfJkFocusHouseOn', () => ({
    scope: {
      cianAfJkFocusHouseOn: '=',
      cianAfJkRotate: '=',
    },
    link(scope, element) {
      scope.$watch(() => scope.cianAfJkFocusHouseOn, input => {
        if (input === true) {
          scope.$applyAsync(() => {
            element[0].focus();
          });
        }
      });

      scope.$watch(() => angular.element(element).attr('aria-expanded'), input => {
        scope.cianAfJkRotate = input === 'true';
        scope.cianAfJkFocusHouseOn = scope.cianAfJkRotate;
      });
    },
  }))
  .directive('cianAfAddressJk', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'jkService', 'addressService', 'logger', '$rootScope', '$scope', '$timeout', 'bsCenterService', 'deviceService',
      // eslint-disable-next-line func-names
      function (jkService, addressService, logger, $rootScope, $scope, $timeout, bsCenterService, deviceService) {
        this.isMobile = deviceService.isMobile;
        this.jkHousesSuggestions = [];

        this.title = 'Название';

        this.updateCategoryConditions = newCategory => {
          this.title = bsCenterService.isBSCategory(newCategory) ? 'или название жилого комплекса' : 'Название';
        };
        $scope.$watch(() => this.ad.category, this.updateCategoryConditions);

        this.needFocusInput = false;
        this.focusInput = e => {
          e.preventDefault();
          this.needFocusInput = !this.needFocusInput;
          if (this.needFocusInput) {
            e.stopPropagation();
          }
        };

        this.getValidationForField = fieldName => {
          const validationMessages = {
            parse: 'Введите корректное значение',
            required: 'Введите значение',
          };

          return validation(this.form, fieldName, validationMessages);
        };

        const onJksUpdate = jks => {
          if (!Array.isArray(jks)) {
            return;
          }

          $rootScope.$emit(addJkMarkers, {
            jks,
            isHouse: false,
          });
        };

        this.updateJks = term => {
          const promise = jkService.getJksWithCurrentGeo({
            term,
          });

          promise.then(onJksUpdate);

          return promise;
        };

        this.updateJK = JK => {
          const isBSCategory = bsCenterService.isBSCategory(this.ad.category);

          this.jkHousesSuggestions = [];
          this.removeJkMarkers();

          if (angular.isObject(JK)) {
            jkService.setNewJKFromObject(JK);
            jkService.setGeoFromNewbuilding(JK.geo);

            if (JK.developers && JK.developers[0]) {
              jkService.setupDeveloper(JK.developers[0]);
            } else {
              jkService.setupDeveloper(null);
            }

            if (isBSCategory) {
              jkService.setBaseInfoAboutBuildingFromJk();
            }

            if (JK.houses && JK.houses.length) {
              this.jkHousesSuggestions = JK.houses;

              const isJKValid = jkService.isJkSelected();

              if (JK.houses.length === 1) {
                jkService.setJkHouse(JK.houses[0]);
              } else if (
                /* Не даем удалить выбранный корпус в категориях коммерческой */
                !isJKValid
              ) {
                this.JKHouse = ''; // Чтобы без значений саджест выдавал все, с null не работает

                jkService.addNewbuildingHouseMarkers(this.jkHousesSuggestions);
              }

              $scope.$applyAsync();
            } else {
              this.JKHouse = null;
            }
          } else {
            const newJk = {
              name: JK,
            };

            // Для регионов где привязка ЖК необязательна оставляем данные о застройщике
            if (!jkService.isJkRegion() && this.ad.geo && this.ad.geo.jk && this.ad.geo.jk.developer) {
              newJk.developer = angular.copy(this.ad.geo.jk.developer);
            }

            jkService.setJk(newJk);
            this.JKHouse = null;

            if (!newJk || !newJk.id) {
              $rootScope.$emit(addressChanged);
            }
          }
        };

        this.updateJKHouse = JKHouse => {
          this.removeJkMarkers();

          if (angular.isObject(JKHouse)) {
            if (this.ad.geo.jk) {
              jkService.setJkHouse(JKHouse);
            }

            jkService.setAboutBuildingFromJk(JKHouse);
          } else if (this.ad.geo.jk) {
            jkService.initializeEmptyJK();

            // Возвращаем маркеры на карту, чтобы юзер мог выбрать другой корпус текущего ЖК
            jkService.addNewbuildingHouseMarkers(this.jkHousesSuggestions);

            jkService.setJkHouse({
              name: JKHouse,
            });
          }
        };

        this.removeJkMarkers = () => $rootScope.$emit(removeJkMarkers);

        /**
         * Сохраняет гео для выбранного ЖК (корпуса) в сервисе.
         * При выборе из списка - берем гео из сервиса, при открытии на редактирование - из ad.geo
         */
        const saveCurrentJKGeo = () => {
          let geo;
          if (angular.isObject(this.JKHouse)) {
            geo = this.JKHouse.geo;
          } else if (angular.isObject(this.JK)) {
            geo = this.JK.geo;
          } else if (this.ad.geo.jk && this.ad.geo.jk.id) {
            geo = {
              address: this.ad.geo.userInput,
              coordinates: this.ad.geo.coordinates,
            };
          }

          addressService.setJkGeo(geo);
        };

        this.selectJKSuggest = JK => {
          const isBSCategory = bsCenterService.isBSCategory(this.ad.category);

          if (isBSCategory && jkService.isJkSelected(false) && JK.id !== this.ad.geo.jk.id) {
            jkService.clearAboutBuilding();
          }

          saveCurrentJKGeo();

          this.updateJK(JK);

          jkService.triggerJkCatalogAddformCheck();

          if (typeof JK === 'object' && JK !== null && Array.isArray(JK.houses) && JK.houses.length === 0) {
            logger.error('У ЖК нет корпусов!', { JK });
          }
        };

        this.selectJKHouseSuggest = JKHouse => {
          saveCurrentJKGeo();

          this.updateJKHouse(JKHouse);
        };

        this.onJKCustomInput = () => {
          this.updateJK(this.form['geo.jk'].$viewValue);
        };

        this.onJKHouseCustomInput = () => {
          this.updateJKHouse(this.form['geo.jk.house'].$viewValue);
        };

        this.isJKValid = () => {
          return jkService.isJkSelected(false);
        };

        this.isJKHouseValid = () => {
          return jkService.isJkSelected(true);
        };

        this.updateNewbuildingHouseSuggestions = houses => {
          this.jkHousesSuggestions = houses;
        };

        if (this.ad.geo && this.ad.geo.jk) {
          this.JK = this.ad.geo.jk.name || null;

          if (this.ad.geo.jk && this.ad.geo.jk.house) {
            this.JKHouse = this.ad.geo.jk.house.name || null;
          }

          jkService.updateNewbuildingFromDatabase().then(() => {
            if (this.ad.geo.jk && Array.isArray(this.ad.geo.jk.houses)) {
              this.updateNewbuildingHouseSuggestions(this.ad.geo.jk.houses);
            }
          });
        }

        $timeout(() => {
          /* Вотчер для отслеживания глобального удаления (отвязки от объявления) объекта ЖК */
          $scope.$watch(() => this.ad.geo && this.ad.geo.jk, (jk, oldJk) => {
            const isOldJkValid = angular.isObject(oldJk) && Number.isFinite(oldJk.id);
            const isJkInvalid = !jk || !jk.id;
            /* Если ЖК был отвязан в this.ad.geo.jk, то синхронизируем интерфейс поиска ЖК с объявлением */
            if (isJkInvalid && isOldJkValid) {
              // Стриггерит вотчер отвязки ЖК
              this.JK = angular.isObject(jk) ? jk.name : jk;
              // Стриггерит отвязку корпуса
              this.JKHouse = '';
              this.jkHousesSuggestions = [];
              this.removeJkMarkers();

              $scope.$applyAsync();
            }
          });

          /* Вотчер для отслеживания смены пина на адрес другого корпуса */
          $scope.$watch(() => this.ad.geo && !!this.ad.geo.jk && this.ad.geo.jk.house, jkHouse => {
            /* Если новый корпус в объявлении валидный, синхронизируем интерфейс с объявлением */
            if (
              angular.isObject(jkHouse) &&
              angular.isObject(this.JKHouse) &&
              this.JKHouse.id !== jkHouse.id
            ) {
              // Стриггерит вотчер смены корпуса
              this.JKHouse = jkHouse.name;

              $scope.$applyAsync();
            }
          });
        });

        $scope.isRequired = () => this.ad.category === 'newBuildingFlatSale';

        $scope.$on('geo.address.changed', (event, address, geoObject) => {
          const JKCoordinates = addressService.getJkGeo() && addressService.getJkGeo().coordinates;
          const AddressCoordinates = geoObject.coordinates;

          const distance = distanceBetween(JKCoordinates, AddressCoordinates);
          // При изменении адреса проверяем насколько он далеко от выбранного ЖК, если расстояние больше 10км убираем жк
          if (distance > MAX_DISTANCE_TO_JK) {
            this.JK = null;
            this.ad.geo.jk = null;
          }
        });
    }],
    controllerAs: 'jk',
    template,
    replace: true,
  }))
  .name;
